import { render, staticRenderFns } from "./rocca-di-frassinello.vue?vue&type=template&id=43eea388&scoped=true"
import script from "./rocca-di-frassinello.vue?vue&type=script&lang=js"
export * from "./rocca-di-frassinello.vue?vue&type=script&lang=js"
import style0 from "./rocca-di-frassinello.vue?vue&type=style&index=0&id=43eea388&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43eea388",
  null
  
)

export default component.exports